import { userToolList } from "app/containers/OnBoarding/helpers";

export const createStages = (onboardingList, form, setFormValue) => [
  {
    title: "How large is your company?",
    type: "single-select",
    options: onboardingList.companySizes,
    value: form.companySize.value,
    className: "max-w-[650px] mb-[56px]",
    onChange: (option) => setFormValue("companySize", option),
  },
  {
    title: "How did you hear about us?",
    type: "single-select",
    options: onboardingList.referalSources,
    value: form.referalSource.value,
    className: "container mx-auto mb-[56px]",
    onChange: (option) => setFormValue("referalSource", option),
  },
  {
    title: "Do you use any of these tools?",
    type: "multi-select",
    options: userToolList(onboardingList.toolPreferences),
    value: form.toolPreferences.value,
    className: "container mx-auto mb-[56px]",
    onChange: (option) => setFormValue("toolPreferences", option),
  },
  {
    title: "Would you like to create your first team?",
    type: "button",
    options: [],
    value: "",
    className: "",
    onChange: () => {},
  },
];
